import { createContext } from "react"

//Context for Visitor updation
export const VisitorContext = createContext()

export default VisitorContext